import { DeliveryRetiradaCard, WappAlertDrawerContainer, WappAlertDrawerElement, WppAlertDrawerClearAndCounter, WppSolvedCard } from './styles';
import { Drawer } from "@material-ui/core";
import React from 'react';
import formatToHourMinute from 'services/formatToHourMinute';
import formatBrazilianPhone from 'services/formatBrazilianPhone';
import { Button, IconCheck, IconClose, IconHelpFilled, IconWhatsapp } from 'takeat-design-system-ui-kit';

export default function WappAlertDrawer({
  isOpenWppAlertList,
  updateOpenWppAlertList,
  handleRedirectToWpp,
  handleCheckHelpRequests,
  checkedWppAlertList  = [],
  uncheckedWppAlertList = [],
  handleDeleteCheckedHelpRequests
}) {
  return <Drawer
    open={isOpenWppAlertList}
    anchor='right'
    onClose={() => updateOpenWppAlertList(false)}
  >
    <WappAlertDrawerContainer>
      <header>
        <p>Solicitações no Whatsapp</p>
        <div>
          <IconClose fill='#545454' onClick={() => updateOpenWppAlertList(false)} fontSize={24} />
        </div>
      </header>
      {uncheckedWppAlertList && uncheckedWppAlertList?.map((wppAlert) => <WappAlertDrawerElement>
        <div>
          <p>
            {wppAlert?.attendance_password ? <>
              Pedido #{wppAlert?.attendance_password} {wppAlert?.comment === 'true' ? <DeliveryRetiradaCard>
                Retirada
              </DeliveryRetiradaCard> : '- Delivery'}
            </> : <>
              <IconHelpFilled fill="#7A7A7A" fontSize={16} />
              Pedido de ajuda
            </>}
          </p>
          <span>{formatBrazilianPhone(wppAlert?.phone_number)}</span>
          <section>{formatToHourMinute(wppAlert?.createdAt)}</section>
        </div>
        <footer>
          <Button onClick={() => handleRedirectToWpp(
            wppAlert?.phone_number,
            wppAlert?.id
          )} size='medium'>
            <IconWhatsapp />
            Abrir conversa
          </Button>
          <Button variant='outlined' size='medium' onClick={() => handleCheckHelpRequests(wppAlert?.id)}>Resolvido</Button>
        </footer>
      </WappAlertDrawerElement>)}
      {checkedWppAlertList.length > 0 && <WppAlertDrawerClearAndCounter>
        <span>Resolvidos ({checkedWppAlertList.length})</span>
        <Button onClick={handleDeleteCheckedHelpRequests} variant='text'>Limpar</Button>
      </WppAlertDrawerClearAndCounter>}
      {checkedWppAlertList && checkedWppAlertList?.map((wppAlert) => <WappAlertDrawerElement style={{ flexDirection: 'row' }}>
        <div>
          <p>
            {wppAlert?.attendance_password ? <>
              Pedido #{wppAlert?.attendance_password} {wppAlert?.comment === 'true' ? <DeliveryRetiradaCard>
                Retirada
              </DeliveryRetiradaCard> : '- Delivery'}
            </> : <>
              <IconHelpFilled fill="#7A7A7A" fontSize={16} />
              Pedido de ajuda
            </>}
          </p>
          <span>{formatBrazilianPhone(wppAlert?.phone_number)}</span>
          <section>{formatToHourMinute(wppAlert?.createdAt)}</section>
        </div>
        <WppSolvedCard>
          <IconCheck fontSize={14} fill='#0F635A'/>Resolvido
        </WppSolvedCard>
      </WappAlertDrawerElement>)}
    </WappAlertDrawerContainer>
  </Drawer>
}